import { render, staticRenderFns } from "./useredit.vue?vue&type=template&id=131eb523&"
import script from "./useredit.vue?vue&type=script&lang=js&"
export * from "./useredit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports